<template>
  <div>
    <div class="d-flex">
      <div class="filter-template">
        <select class="btn btn-secondary dropdown-toggle" v-model="year" style="margin-left: 20px; padding:10px">
          <option v-for="year in yearRange">{{ year }}</option>
        </select>
      </div>
      <div class="filter-template">
        <select class="btn btn-secondary dropdown-toggle" v-model="month" style="margin-left: 20px; padding:10px">
          <option value="0">Année complète</option>
          <option value="1">{{ $t('months')[0] }}</option>
          <option value="2">{{ $t('months')[1] }}</option>
          <option value="3">{{ $t('months')[2] }}</option>
          <option value="4">{{ $t('months')[3] }}</option>
          <option value="5">{{ $t('months')[4] }}</option>
          <option value="6">{{ $t('months')[5] }}</option>
          <option value="7">{{ $t('months')[6] }}</option>
          <option value="8">{{ $t('months')[7] }}</option>
          <option value="9">{{ $t('months')[8] }}</option>
          <option value="10">{{ $t('months')[9] }}</option>
          <option value="11">{{ $t('months')[10] }}</option>
          <option value="12">{{ $t('months')[11] }}</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: ['source'],
  data() {
    return {
      year: moment().format('YYYY'),
      month: moment().format('M'),
      yearRange: [],
      dateFiltered: {
        year: moment().format('YYYY'),
        month: moment().format('M'),
      },
      filterFallback: () => {},
    };
  },
  methods: {
    clearAll: function () {
      this.year = moment().format('YYYY');
      this.month = moment().format('M');
      this.filter();
    },
    filter: function (setStorage = true) {
      if (setStorage) {
        localStorage.setItem(this.source, JSON.stringify(this.dateFiltered));
      }
      this.filterFallback(this.dateFiltered);
    },
    updateOnStorage: function() {
      const exists = localStorage.getItem(this.source);
      if(exists) {
        this.dateFiltered = JSON.parse(exists);
        this.filter(false);
      }else {
        localStorage.setItem(this.source, JSON.stringify(this.dateFiltered));
        this.clearAll();
      }
    },
  },
  async mounted() {
    for (let i = 2014; i <= moment().add(2, 'years').year(); i++) {
      this.yearRange.push(i);
    }

    this.$root.$on(this.source + '_setDateFilterFallback', fallback => {
      this.filterFallback = fallback;
      this.updateOnStorage();
    });

    if(this.dateFiltered && this.dateFiltered.month) {
      this.filter();
    }
  },
  watch: {
    year: {
      handler: function (newVal) {
        this.dateFiltered.year = newVal;
      }
    },
    month: {
      handler: function (newVal) {
        this.dateFiltered.month = newVal;
      }
    },
    dateFiltered: {
      handler: function (newVal) {
        this.filter();
      },
      deep: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// DateFilterSelectorTemplate.vue?b0d2a244